var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.18268 9.68341L10.2952 5.57091L9.47851 4.75425L6.18268 8.05008L4.52018 6.38758L3.70352 7.20425L6.18268 9.68341ZM6.99935 12.8334C6.1924 12.8334 5.43407 12.6803 4.72435 12.374C4.01463 12.0678 3.39727 11.6522 2.87227 11.1272C2.34727 10.6022 1.93164 9.9848 1.62539 9.27508C1.31914 8.56536 1.16602 7.80703 1.16602 7.00008C1.16602 6.19314 1.31914 5.4348 1.62539 4.72508C1.93164 4.01536 2.34727 3.398 2.87227 2.873C3.39727 2.348 4.01463 1.93237 4.72435 1.62612C5.43407 1.31987 6.1924 1.16675 6.99935 1.16675C7.80629 1.16675 8.56463 1.31987 9.27435 1.62612C9.98407 1.93237 10.6014 2.348 11.1264 2.873C11.6514 3.398 12.0671 4.01536 12.3733 4.72508C12.6796 5.4348 12.8327 6.19314 12.8327 7.00008C12.8327 7.80703 12.6796 8.56536 12.3733 9.27508C12.0671 9.9848 11.6514 10.6022 11.1264 11.1272C10.6014 11.6522 9.98407 12.0678 9.27435 12.374C8.56463 12.6803 7.80629 12.8334 6.99935 12.8334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleWhite);
export default __webpack_public_path__ + "static/media/check_circle_white.778963f20a7fda2c8018690395a077d8.svg";
export { ForwardRef as ReactComponent };